import React from 'react';
import { Chart } from 'react-google-charts';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import './AssChart.css';

class AssChart extends React.Component {
  constructor(props) {
    super(props);
    var options = {
      pieHole: 0.4,
      legend: 'none',
      title: this.props.title,
      theme: 'material',
      chartArea: {'width': '80%', 'height': '80%'},
      showRowNumber: true,
      width: '100%'
    };

    if (this.props.isPercentChart) {
      options.vAxis = {
        minValue: 0,
        maxValue: 100,
        format: '#\'%\''
      };
    }

    if (this.props.isStacked) {
      options.isStacked = true;
    }

    this.initialState =  {
      data: null,
      style: {},
      enlarged: false,
      options
    };

    this.state = {
      ...this.initialState
    };
    this.chartEvents = [
      {
        eventName: 'select',
        callback: (Chart) => {
          const selection = Chart.chart.getSelection();
          const key = this.props.aggregate.groupBy;
          if (selection.length === 0) {
            this.props.cancelFilter(key);
            return;
          }

          const row = Chart.chart.getSelection()[0].row;
          const selectedValue = this.state.data[row+1][0];

          if (selectedValue === this.state.selectedValue) {
            this.setState({selectedValue: null});
            this.props.cancelFilter(key);
          } else {
            this.setState({selectedValue});
            this.props.onNewFilter(key, selectedValue);
          }
        },
      },
      {
        eventName: 'ready',
        callback: (Chart) => {
          this.setState({chart: Chart.chart});
        }
      }
    ];

  }

  componentWillReceiveProps = (nextProps) => {

    if (!nextProps.data || !nextProps.filters) return;

    const filters = Object.keys(nextProps.filters)
      .filter(filterBy => (filterBy !== this.props.aggregate.groupBy))
      .map(filterBy => (
        obj => ( obj[filterBy] === nextProps.filters[filterBy])
      ));

    const filteredData = nextProps.data.filter((obj) => (
      filters.map(filter => filter(obj)).every(result => result)
    ));

    if (filteredData.length === 0) {
      this.setState({data: filteredData});
      return;
    }

    const sortedData = this.sortData(filteredData);

    const data = this.props.aggregate.fn(sortedData);

    this.setState({data});

    if (this.props.aggregate.groupBy in nextProps.filters) {
      // Use timeout so that chart has enough time to set new data
      setTimeout(() => {
        const index = this.state.data.findIndex((row) => (row[0] === nextProps.filters[this.props.aggregate.groupBy]));
        const row = index -1;
        if(this.state.chart) {
          this.state.chart.setSelection([{row}]);
        }
      }, 10);
    }
  }

  sortData = (data) => {
    if (this.props.sortBy) {
      return data.sort((a, b) => (a[this.props.sortBy] - b[this.props.sortBy]));
    }
    if (this.props.sortByCallback) {
      return data.sort(this.props.sortByCallback);
    }
    return data;
  }

  toggleEnlargeChart = () => {
    if (!this.state.enlarged)  {
      const style = {
        minWidth: '800px',
        minHeight: '800px',
      };
      this.setState({style, enlarged: true});
    } else {
      // There is some fuckery going on with flex and chrome so that smaller size doesn't update
      // wihtout first hiding the element
      this.setState({style: {display: 'none'}, enlarged: false});
      setTimeout(() => {this.setState({style: {display: 'flex'}, enlarged: false});}, 1);
    }
    this.props.onEnlargeToggled();
  }

  render() {
    const buttonStyle = {
      position: 'absolute',
      right: '0',
    };

    const {t} = this.props;

    const googleChart = <Chart
      chartType={this.props.chartType}
      data={this.state.data}
      options={this.state.options}
      width="100%"
      height="100%"
      legend_toggle
      chartEvents={this.chartEvents}
    />;

    const tableChart = <div className='tableChart'>
      <div className='titleTableChart'>
        {this.props.title}
      </div>
      {googleChart}
    </div>;

    let chart = null;

    if (this.state.data && this.state.data.length <= 1 ) {
      chart = <div className='noDataChart'>
        {this.props.title}
        <div className='messageNoDataChart'>
          {t('dashboard.noData')}
        </div>
      </div>;
    } else if (this.state.data) {
      chart = (this.props.chartType === 'Table') ? tableChart : googleChart;
    }

    const divStyle = {
      ...this.props.style,
      ...this.state.style
    };

    return (
      <div style={divStyle}>
        <FlatButton
          style={buttonStyle}
          icon={<ActionSearch />}

          onTouchTap={this.toggleEnlargeChart} />
        {chart}
      </div>
    );
  }
}

export default translate()(AssChart);



// WEBPACK FOOTER //
// ./src/Dashboard/AssChart.js